import React from 'react';
import { stats } from '../data/site';
export function StatsBar() {
  return <section aria-label="Menopause Decision Desk at a glance" className="w-full bg-navy px-5 py-8 sm:px-6 sm:py-10" data-id="element-285" data-mp="1tai1x90mmpqa">
      <dl className="mx-auto grid max-w-4xl grid-cols-2 gap-y-7 sm:grid-cols-4 sm:gap-y-0" data-id="element-286" data-mp="1oavp30opnbi0">
        {stats.map((stat, i) => <div key={stat.label} className={`flex flex-col items-center px-2 text-center ${i % 2 === 1 ? 'border-l border-white/12' : ''} sm:border-l sm:border-white/12 sm:first:border-l-0`} data-id="element-287" data-mp="1jbiu1snoqy4c" data-mpi={i}>
            <dt className="sr-only" data-id="element-288" data-mp="15knsz2jfhlbb">{stat.label}</dt>
            <dd className="font-serif text-[30px] font-bold leading-none text-gold-light sm:text-4xl" data-id="element-289" data-mp="15lfaxak3rkj4">
              {stat.value}
            </dd>
            <p className="mt-2 max-w-[9rem] text-[11px] font-bold uppercase leading-snug tracking-[0.1em] text-cream/75" data-id="element-290" data-mp="vmgdko4sfbbf">
              {stat.label}
            </p>
          </div>)}
      </dl>
    </section>;
}